import { validateEmail, validateUrl } from './schemaUtilities';
export function hasErrorInStep(stepFields, errorField) {
  return stepFields.findIndex(({
    getName
  }) => getName() === errorField) !== -1;
}
export function checkStepCompleted(stepFields) {
  for (const stepField of stepFields) {
    if ('checkComplete' in stepField) {
      if (!stepField.checkComplete()) {
        return false;
      }
      continue;
    }
    if (stepField.isRequired()) {
      const value = stepField.getValue();
      const schema = stepField.getSchema();
      if (schema.type === 'string') {
        if (typeof value !== 'string') {
          return false;
        }
        if ('minLength' in schema && value.length < schema.minLength) {
          return false;
        }
        if ('maxLength' in schema && value.length > schema.maxLength) {
          return false;
        }
        if ('format' in schema) {
          if (schema.format === 'oaf-email' && !validateEmail(value)) {
            return false;
          }
          if (schema.format === 'oaf-url' && !validateUrl(value)) {
            return false;
          }
        }
      } else if (schema.type === 'number') {
        if (typeof value !== 'number') {
          return false;
        }
        if ('minimum' in schema && value < schema.minimum) {
          return false;
        }
        if ('maximum' in schema && value > schema.maximum) {
          return false;
        }
      } else if (schema.type === 'array') {
        if (!Array.isArray(value)) {
          return false;
        }
        if ('minItems' in schema && value.length < schema.minItems) {
          return false;
        }
      }
    }
  }
  return true;
}